import React, { useState, useEffect } from 'react';
import {
	Box,
	Button,
	HStack,
	Table,
	Thead,
	Tbody,
	Tr,
	Th,
	Td,
	TableContainer,
	useDisclosure,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalCloseButton,
	ModalBody,
	ModalFooter,
	Input,
	Switch,
	FormControl,
	FormLabel,
	FormErrorMessage,
} from '@chakra-ui/react'
import { Link } from "react-router-dom";
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { fetchWrapper } from '../../../helpers';
import CustomModalLink from '../../../components/CustomModalLink'
import { SketchPicker } from 'react-color';
import PageLoader from '../../../components/Loader/PageLoader';

function List() {
	const { isOpen, onOpen, onClose } = useDisclosure();
	const { onOpen: onOpenEdit } = useDisclosure();
	const [isOpenEdit, setIsOpenEdit] = useState(false)
	const [modalEditView, setModalEditView] = useState(false)
	const [list, setList] = useState([])
	const [loading, setLoading] = useState(false);
	const [mode, setMode] = useState('create'); // 'create' or 'edit'

	const [obj, setObject] = useState({});

	useEffect(() => {
		loadList();
	}, [])

	const loadList = async () => {
		setLoading(true)
		const url = `${process.env.REACT_APP_API_URL}/channel/list`;
		const data = await fetchWrapper.get(url)
		setList(data.data);
		setLoading(false)
	}

	const meCloseEdit = () => {
		setIsOpenEdit(false);
	}

	// Formik initial values
	const initialValues = {
		channel_name: '',
		color: '',
		is_config: false,
		is_mute: true,
	};

	// Yup validation schema
	const validationSchema = Yup.object({
		name: Yup.string().required('Channel Name is required'),
		color: Yup.string().required('Color is required'),
		is_config: Yup.boolean(),
		is_mute: Yup.boolean(),
	});

	// Handle form submission
	const handleSubmit = async (values, { resetForm }) => {
		try {
			if (mode === 'edit') {
				const url = `${process.env.REACT_APP_API_URL}/channel/update`;
				await fetchWrapper.post(url, values);
			} else {
				const url = `${process.env.REACT_APP_API_URL}/channel/create`;
				await fetchWrapper.post(url, values);
			}

			loadList();
			resetForm();
			onClose();
			setMode('create'); // Reset to create mode
			setObject({});
		} catch (error) {
			console.error('Error submitting form:', error);
		}
	};


	const handleOpenEdit = (rs) => {
		setObject({
			name: rs.name,
			color: rs.color || '#000000',
			is_config: rs.is_config === 1,
			is_mute: rs.is_mute === 1,
			id: rs.id
		});
		setMode('edit');
		onOpen();
	};

	const getInitialValues = () => {
		return mode === 'edit' && obj
			? {
				name: obj.name || '',
				color: obj.color || '',
				is_config: obj.is_config || false,
				is_mute: obj.is_mute || false,
				id: obj?.id
			}
			: {
				name: '',
				color: '',
				is_config: false,
				is_mute: true,

			};
	};

	return (
		<>

			<PageLoader isLoading={loading} />

			{/* Create Channel Modal */}
			<Modal isOpen={isOpen} onClose={onClose}>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>{mode === 'edit' ? 'Edit Channel' : 'Create New Channel'}</ModalHeader>

					<ModalCloseButton />
					<Formik
						initialValues={getInitialValues()}
						validationSchema={validationSchema}
						onSubmit={handleSubmit}
					>
						{({ isSubmitting }) => (
							<Form>
								<ModalBody pb={6}>
									<Field name="name">
										{({ field, form }) => (
											<FormControl isInvalid={form.errors.channel_name && form.touched.channel_name} mb={4}>
												<FormLabel>Channel Name</FormLabel>
												<Input {...field} placeholder="Channel Name" />
												<FormErrorMessage>{form.errors.channel_name}</FormErrorMessage>
											</FormControl>
										)}
									</Field>

									<Field name="color">
										{({ field, form }) => (
											<FormControl isInvalid={form.errors.color && form.touched.color} mb={4}>
												<FormLabel>Color</FormLabel>
												<SketchPicker
													color={field.value}
													onChangeComplete={(color) => {
														form.setFieldValue('color', color.hex);
													}}
												/>
												{form.errors.color && <FormErrorMessage>{form.errors.color}</FormErrorMessage>}
											</FormControl>
										)}
									</Field>


									<Field name="is_config" type="checkbox">
										{({ field }) => (
											<FormControl display="flex" alignItems="center" mb={4}>
												<FormLabel mb="0">Is Config</FormLabel>
												<Switch {...field} isChecked={field.value} />
											</FormControl>
										)}
									</Field>

									<Field name="is_mute" type="checkbox">
										{({ field }) => (
											<FormControl display="flex" alignItems="center">
												<FormLabel mb="0">Is Mute</FormLabel>
												<Switch {...field} isChecked={field.value} />
											</FormControl>
										)}
									</Field>

								</ModalBody>

								<ModalFooter>
									<Button colorScheme="blue" mr={3} type="submit" isLoading={isSubmitting}>
										Save
									</Button>
									<Button onClick={onClose}>Cancel</Button>
								</ModalFooter>
							</Form>
						)}
					</Formik>
				</ModalContent>
			</Modal>

			<CustomModalLink
				showModalButtonText="Status Edit"
				modalHeader="Status Edit"
				isOpenEdit={isOpenEdit}
				onCloseEdit={meCloseEdit}
				onOpenEdit={onOpenEdit}
				modalBody={modalEditView}
			/>

			<div className="setting_detail_section">
				<HStack justifyContent="space-between" mb={4}>
					<Box>
						<h2 className="main_heading">Channels</h2>
					</Box>
					<Button colorScheme="blue" onClick={onOpen}>
						Create Channel
					</Button>
				</HStack>

				<div className="table_section">
					<TableContainer width="100%">
						<Table variant='simple' width="100%" borderWidth="1px" borderColor="#CCCCCC" borderStyle="solid">
							<Thead >
								<Tr>
									<Th>Channel Name</Th>
									<Th>No of Accounts</Th>
									<Th></Th>
								</Tr>
							</Thead>

							<Tbody fontSize="14px">
								{list.map((rs, index) => {
									return (
										<Tr key={rs?.id}>
											<Td><span style={{ color: "#0000EE", cursor: "pointer" }} onClick={() => handleOpenEdit(rs)}>{rs.name}</span></Td>
											<Td>{rs?.ChannelApiConfigs?.length > 0 ? rs?.ChannelApiConfigs?.length : ""}</Td>
											<Td style={{ color: "#0000EE" }}>
												{rs?.is_config === 1 ? <Link
													to={`/settings/channel-api-config/${rs.id}?name=${rs.name}`}
													state={{ id: rs.id }}
												>
													Manage Account
												</Link> : ""}

											</Td>
										</Tr>

									)
								})}
							</Tbody>
						</Table>
					</TableContainer>
				</div>
			</div>
		</>
	)
}

export default List;
